import { faDiamond } from "@jewlr/sharp-solid-svg-icons/faDiamond"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import { jewlr_t } from "helpers/application"

import WizardLoading from "./loaders/wizard-loading"
import AccordionContent from "./wizard-options/accordion-content"
import AccordionHeading from "./wizard-options/accordion-heading"
import MetalSelectionStatic from "./wizard-options/metal-selection-static"
// import UnifiedStonePicker from "./wizard-options/unified-stone-picker"

// const isStonePref = (pref) => /^s\d+$/.test(pref)

const InternalWizardOptions = ({
  adminMode,
  prefOrder,
  wizardLoading,
  // unifiedStonePickerExp,
  // wizardData,
}) => {
  // Check if a pref qualifies for unified stone picker
  // const shouldUseUnifiedStonePicker = (pref) => {
  //   if (pref === "sc") return true
  //   if (pref === "o1") {
  //     const o1Data = wizardData?.o1
  //     const hasStoneOptions = Object.keys(wizardData || {}).some((key) =>
  //       /^s\d+$/.test(key)
  //     )
  //     return (
  //       o1Data &&
  //       o1Data.title?.toLowerCase().includes("number") &&
  //       hasStoneOptions
  //     )
  //   }
  //   return false
  // }

  // const useUnifiedStonePickerVariant =
  //   unifiedStonePickerExp === 1 &&
  //   prefOrder.some((pref) => shouldUseUnifiedStonePicker(pref))

  return (
    <div className="border-t-grey-400 tablet:border-t-grey-10 overflow-hidden border-t">
      <Media
        className="border-b-grey-10 flex items-center border-b py-12"
        lessThan="tablet"
      >
        <FontAwesomeIcon
          className="text-12 text-primary mr-6"
          icon={faDiamond}
        />
        <h2 className="text-16 font-semibold">
          {jewlr_t("terms.Personalize")} It
        </h2>
      </Media>
      {wizardLoading ? (
        <WizardLoading />
      ) : (
        // ) : useUnifiedStonePickerVariant ? (
        //   prefOrder
        //     .filter((pref) => !(adminMode && pref == "gift"))
        //     .filter((pref) => !isStonePref(pref))
        //     .map((pref) => {
        //       if (shouldUseUnifiedStonePicker(pref)) {
        //         return (
        //           <div data-cy={`wizard-accordion-${pref}`} key={`wopt-${pref}`}>
        //             <UnifiedStonePicker panel={pref} pref={pref} />
        //           </div>
        //         )
        //       }

        //       // Static metal selection for ab test
        //       // if (index === 0 && pref === "sku") {
        //       //   return <MetalSelectionStatic key={`wopt-${pref}`} pref={pref} />
        //       // }

        //       // Render other prefs normally
        //       return (
        //         <div data-cy={`wizard-accordion-${pref}`} key={`wopt-${pref}`}>
        //           <AccordionHeading pref={pref} />
        //           <AccordionContent panel={pref} pref={pref} />
        //         </div>
        //       )
        //     })
        prefOrder
          .filter((pref) => !(adminMode && pref == "gift"))
          .map((pref, i) => {
            if (pref === "sku" && i === 0) {
              return <MetalSelectionStatic key={`wopt-${pref}`} pref={pref} />
            }

            return (
              <div data-cy={`wizard-accordion-${pref}`} key={`wopt-${pref}`}>
                <AccordionHeading pref={pref} />
                <AccordionContent panel={pref} pref={pref} />
              </div>
            )
          })
      )}
    </div>
  )
}

InternalWizardOptions.propTypes = {
  adminMode: PropTypes.bool,
  prefOrder: PropTypes.array,
  // unifiedStonePickerExp: PropTypes.number,
  // wizardData: PropTypes.object,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    adminMode: state.wizard.adminMode,
    prefOrder: state.wizard.prefOrder,
    // unifiedStonePickerExp: state.experiment.unifiedStonePicker?.variant_id,
    // wizardData: state.wizard.data,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => {
  return {}
}

const WizardOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalWizardOptions)

export default WizardOptions
